import { isBrowser } from "@util/isBrowser";

export const pushDataLayerEvent = (event: string, props: { [key: string]: any } = {}) => {
    if (isBrowser() && (window as any).dataLayer) {
        (window as any).dataLayer.push({ event, ...props });
    }
};

export const getTrackingPropsAsDataAttrs = (props: { clickEvent?: string; viewEvent?: string; eventProps?: any }) => {
    const trackingProps: { [key: string]: string } = {};
    if (props.clickEvent) {
        trackingProps.oskarClick = props.clickEvent;
    }
    if (props.viewEvent) {
        trackingProps.oskarView = props.viewEvent;
    }
    trackingProps.oskarProps = JSON.stringify(props.eventProps || {});
    return trackingProps;
};
